import React from 'react'
import { Search, X } from 'lucide-react'
import { Input } from '../ui/Input'
import { Button } from '../ui/Button'
import { cn } from '../../lib/utils'

const SearchBar = ({ 
  value, 
  onChange, 
  onClear, 
  placeholder = "Search projects...", 
  className,
  ...props 
}) => {
  return (
    <div className={cn("relative group", className)} {...props}>
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-neutral-500 group-focus-within:text-primary-teal transition-colors" />
      
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        className="pl-10 pr-10 h-12 bg-white border-neutral-300 focus:border-primary-teal focus:ring-primary-teal/20 transition-all duration-200"
      />
      
      {value && (
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-1 top-1/2 transform -translate-y-1/2 h-8 w-8 text-neutral-500 hover:text-neutral-700"
          onClick={() => {
            onChange?.('')
            onClear?.()
          }}
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  )
}

export default SearchBar
